/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} From_Price_Per_SeedInputs */

const en_from_price_per_seed = /** @type {(inputs: From_Price_Per_SeedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`From ${i?.price} per seed`)
};

const th_from_price_per_seed = /** @type {(inputs: From_Price_Per_SeedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เริ่มต้นที่ ${i?.price} ต่อเมล็ด`)
};

const ja_from_price_per_seed = /** @type {(inputs: From_Price_Per_SeedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`1粒 ${i?.price} 〜`)
};

const fr_from_price_per_seed = /** @type {(inputs: From_Price_Per_SeedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`À partir de ${i?.price} par graine`)
};

const es_from_price_per_seed = /** @type {(inputs: From_Price_Per_SeedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Desde ${i?.price} por semilla`)
};

const ru_from_price_per_seed = /** @type {(inputs: From_Price_Per_SeedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`От ${i?.price} за семя`)
};

const zh_from_price_per_seed = /** @type {(inputs: From_Price_Per_SeedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`每粒 ${i?.price} 起`)
};

const vi_from_price_per_seed = /** @type {(inputs: From_Price_Per_SeedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Từ ${i?.price} mỗi hạt`)
};

/**
* | output |
* | --- |
* | "From {price} per seed" |
*
* @param {From_Price_Per_SeedInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const from_price_per_seed = /** @type {((inputs: From_Price_Per_SeedInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<From_Price_Per_SeedInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_from_price_per_seed(inputs)
	if (locale === "ja") return ja_from_price_per_seed(inputs)
	if (locale === "fr") return fr_from_price_per_seed(inputs)
	if (locale === "es") return es_from_price_per_seed(inputs)
	if (locale === "ru") return ru_from_price_per_seed(inputs)
	if (locale === "zh") return zh_from_price_per_seed(inputs)
	if (locale === "vi") return vi_from_price_per_seed(inputs)
	return en_from_price_per_seed(inputs)
});